import { mapState } from "vuex";

import formable from "@/mixins/formable";
import CVatCodeCheck from "@/components/widgets/CVatCodeCheck";

import {
  GET_TAGS_LIST
} from "@/store/tags/actions";

import {
  DATA_ISO639_2,
  DATA_ISO_COUNTRIES_2_LETTERS
} from "@/store/data/actions";

import data from "@/mixins/data";
import address from "@/mixins/address";

export default {
  mixins: [
    formable,
    data,
    address
  ],
  components: {
    CVatCodeCheck
  },
  props: [
    'companyId'
  ],
  data() {
    return {
      form: {
        name: null,
        first_name: null,
        last_name: null,
        type: 1,
        locale: this.$locale(),
      },
      activeTab: "tab-main",
      search: null,
    };
  },
  beforeMount() {
    if (!!this.companyId) {
      this.form.company_id = this.companyId;
    }

    this.$store.dispatch(GET_TAGS_LIST);
    this.$store.dispatch(DATA_ISO639_2);
    this.$store.dispatch(DATA_ISO_COUNTRIES_2_LETTERS);
  },
  methods: {
    resetPrivate() {
      if (!this.item) {
        return false;
      }

      this.form.first_name = this.item.first_name;
      this.form.last_name = this.item.last_name;
      this.form.sdi = '0000000';
    },
    resetCompany() {
      if (!this.item) {
        return false;
      }

      this.form.SDI = this.item.SDI;
      this.form.taxcode = this.item.taxcode;
      this.form.vatcode = this.item.vatcode;
    },
    splitName(val) {
      if (!val) {
        return false;
      }

      let split = val.split(" ");
      
      if (split.length >= 2) {
        this.form.first_name = split[0].charAt(0).toUpperCase() + split[0].slice(1);
        this.form.last_name = split[split.length - 1].charAt(0).toUpperCase() + split[split.length - 1].slice(1);
      }
    },
    updateFormData(data) {
      this.form = {
        ...this.form,
        ...data
      };
    }
  },
  computed: {
    ...mapState({
      tags: state => state.tags.getListRequest.list,
    }),
    initialized() {
      return true;
    },
    isCompany() {
      return this.form.type === this.$const('ConstClientType', 'COMPANY') ||
        this.form.type === this.$const('ConstClientType', 'PUBLIC_ADMINISTRATION')
    }
  },
  watch: {
    "form.type": {
      handler(val) {
        if (val === this.$const('ConstClientType', 'COMPANY')) {
          this.resetCompany();
        }
        if (val === this.$const('ConstClientType', 'PRIVATE')) {
          this.resetPrivate();
        }
      },
      deep: true
    },
  }
};
